export default __webpack_public_path__ + "assets/89f444383229b077cdf61ff48645a7eb.jpeg";